import axios from "axios";
import { keycloak } from "../keycloak";
import { CompanyConfirmDTO } from "./dto";
import { CompanyToConfirmService } from "./service";

export class CompanyToConfirmServiceImpl implements CompanyToConfirmService {

    public confirmCompany(data: CompanyConfirmDTO[]): Promise<void> {
        let url: string = "/api/companies/confirm"
        return axios({
            url: url,
            method: "POST",
            data: data,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}
